import { useEffect } from "react";
import Lenis from "lenis";
import { Header } from "../components/marketing/Header";
import { Hero } from "../components/marketing/Hero";
import { EditorialMarquee } from "../components/marketing/Marquee";
import { Manifesto } from "../components/marketing/Manifesto";
import { Services } from "../components/marketing/Services";
import { Insights } from "../components/marketing/Insights";
import { Contact } from "../components/marketing/Contact";
import { Footer } from "../components/marketing/Footer";
import { WhatsAppButton } from "../components/marketing/WhatsAppButton";

export default function LandingPage() {
  useEffect(() => {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    let rafId;
    const loop = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(loop);
    };
    rafId = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  useEffect(() => {
    if (window.location.hash) {
      const el = document.getElementById(window.location.hash.slice(1));
      if (el) setTimeout(() => el.scrollIntoView({ behavior: "smooth" }), 700);
    }
  }, []);

  return (
    <div className="grain bg-brand-paper text-brand-ink font-satoshi" data-testid="landing-page">
      <Header />
      <main>
        <Hero />
        <EditorialMarquee />
        <Manifesto />
        <Services />
        <Insights />
        <Contact />
      </main>
      <Footer />
      <WhatsAppButton />
    </div>
  );
}
